export default __webpack_public_path__ + "assets/images/b19215c9fe8c125da66e55110ad7e0f2.png";